import { SET_DESKTOP_MENU_OPEN_STATE, SET_DESKTOP_MENU_SHADOW } from '../../mutation-types';

export default {
    [SET_DESKTOP_MENU_SHADOW](state, { hasBigShadow }) {
        state.hasBigShadow = hasBigShadow;
    },
    [SET_DESKTOP_MENU_OPEN_STATE](state, { isOpen }) {
        state.isOpen = isOpen;
    },
};
